/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { forwardRef } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import MenuItem from "@mui/material/MenuItem";
import Link from "@mui/material/Link";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// custom styles for the NotificationItem
import menuItem from "examples/Items/NotificationItem/styles";

const NotificationItem = forwardRef(({ icon, title, ...rest }, ref) => (
  <MenuItem
    {...rest}
    ref={ref}
    sx={(theme) => ({
      ...menuItem(theme),
      borderRadius: '10px',
    })}
  >
    <MDBox
      py={0.75}
      px={0.5}
      display="flex"
      alignItems="flex-start"
      lineHeight={1}
      sx={{ whiteSpace: 'normal', width: '100%' }}
    >
      <MDTypography variant="body1" lineHeight={0.75} sx={{ display: 'flex', alignItems: 'center' }}>
        {icon}
      </MDTypography>
      <MDBox sx={{ ml: 1, flex: 1, minWidth: 0 }}>
        {typeof title === 'string' ? (
          <MDTypography variant="body2" fontWeight="regular" sx={{ whiteSpace: 'normal' }}>{title}</MDTypography>
        ) : (
          title
        )}
      </MDBox>
    </MDBox>
  </MenuItem>
));

// Typechecking props for the NotificationItem
NotificationItem.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

export default NotificationItem;
